import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TEAM } from "@/data/content";
import { PageHero, Breadcrumbs, TestimonialBand, FadeIn } from "@/components/Shared";

const FIRM_RESULTS = [
  {
    title: "R v O — Russia sanctions",
    text: "The first prosecution under the UK's Russia Regulations. Our client was acquitted following a 4-week trial at Southwark Crown Court.",
    outcome: "Acquitted",
  },
  {
    title: "R v W — bribery & money laundering",
    text: "Acquittal of an individual charged with bribery and money laundering following trial at Southwark Crown Court, relating to the office fit out industry.",
    outcome: "Acquitted",
  },
  {
    title: "Grenfell Tower Inquiry",
    text: "Representing a Core Participant in Phase 2 of one of the most significant public inquiries in recent history.",
    outcome: "Core Participant representation",
  },
  {
    title: "R v A — rape allegation",
    text: "Acquittal of an individual charged with rape following trial at Inner London Crown Court.",
    outcome: "Acquitted",
  },
  {
    title: "Stephen Port Inquest",
    text: "Representing an Interested Party following the rape and murder of four young men in East London.",
    outcome: "Interested Party representation",
  },
  {
    title: "EncroChat operations",
    text: "Represented multiple individuals charged with wide scale cocaine supply arising from the EncroChat encrypted communications operation.",
    outcome: "Complex conspiracy defence",
  },
  {
    title: "R v H — Central Criminal Court",
    text: "Four handed murder trial at the Central Criminal Court where zombie knives were purchased on Snapchat.",
    outcome: "Murder trial defence",
  },
  {
    title: "R v X — Government department fraud",
    text: "Early advice provided to an individual charged with fraud on a major Government department. Following a 10-year delay, achieved a sentence of a fine.",
    outcome: "Sentence: fine",
  },
  {
    title: "R v K — cryptocurrency & DarkWeb",
    text: "Cryptocurrency, DarkWeb and fake Xanax tablets — the subject of the case at Portsmouth Crown Court.",
    outcome: "Specialist digital evidence defence",
  },
  {
    title: "Crown Court drug offences",
    text: "Recent case success: a conditional discharge secured in the Crown Court for drug-related offences.",
    outcome: "Conditional discharge",
  },
];

export default function Results() {
  return (
    <main data-testid="results-page">
      <PageHero
        eyebrow="Our results"
        title="Outcomes that speak for themselves."
        lead="From the first prosecution under the Russia sanctions regime to murder trials at the Central Criminal Court — a selection of the cases and outcomes our team has been trusted with."
      />
      <Breadcrumbs items={[{ label: "Our Results" }]} />

      <section className="bg-white py-20 sm:py-28 lg:py-32">
        <div className="brand-container">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            {FIRM_RESULTS.map((r, i) => (
              <FadeIn key={i} delay={(i % 2) * 0.08}>
                <div className="brand-card flex h-full flex-col p-8" data-testid={`result-card-${i}`}>
                  <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-terracotta">
                    {r.outcome}
                  </p>
                  <h3 className="mt-3 text-lg font-medium text-brand-navy">{r.title}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{r.text}</p>
                </div>
              </FadeIn>
            ))}
          </div>
          <FadeIn delay={0.2}>
            <div className="mt-12 flex flex-col items-start justify-between gap-6 border-t border-slate-200 pt-8 sm:flex-row sm:items-center">
              <p className="max-w-xl text-sm leading-relaxed text-slate-500">
                Every case is different and past results do not guarantee future
                outcomes — but they do demonstrate the calibre of work we are trusted
                with, and the tenacity we bring to it.
              </p>
              <Link
                to={`/team/${TEAM[0].slug}`}
                className="brand-text-link flex shrink-0 items-center gap-2"
                data-testid="results-namita-link"
              >
                More cases on Namita Pawa's profile <ArrowRight className="size-3.5" />
              </Link>
            </div>
          </FadeIn>
        </div>
      </section>

      <TestimonialBand />
    </main>
  );
}
